export function buildBrandAssetPath(
  brandKey: string,
  asset: 'logo' | 'company-icon' | 'ai-icon' | 'favicon'
) {
  const ext = asset === 'favicon' ? '.ico' : '.svg';
  return `/brand/${brandKey}/${asset}${ext}`;
}

export function buildFaviconPngPath(brandKey: string) {
  return `/brand/${brandKey}/favicon.png`;
}
